import { render } from "./Main.vue?vue&type=template&id=31fecb2d&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=31fecb2d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-31fecb2d"

export default script